import React, { useState } from "react";
import "./AthleteDetails.css";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Loader, Button, Icon } from "semantic-ui-react";
import "../layout/Spinner.css";
import AthleteVideoList from "./AthleteVideoList";
import AthleteImageList from "./AthleteImageList";
import AthleteSocialMediaList from "./AthleteSocialMediaList";
import AthleteCoachList from "./AthleteCoachList";
import AthleteAwardsHonorsList from "./AthleteAwardsHonorsList";
import AthleteExtrasList from "./AthleteExtrasList";
import AthleteRequestForm from "./AthleteRequestForm";
import AthleteCalendar from "./AthleteCalendar";
import AthleteEventsList from "./AthleteEventsList";
import AthletesStatsPhotos from "../layout/StatsPhotos/AthletesStatsPhotos";
// import Seo from "../layout/Seo";
const athleteDetailsReduxSchoolsIdList = "athleteDetailsSchoolsIdList";
export const settingsSchool = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1800,
  arrows: false,
  cssEase: "linear",
};
var athleteGpa = null;

const AthleteDetails = (props) => {
  const [requestMoreInfo, setRequestMoreInfo] = useState(false);

  const { athlete } = props;

  const schools = props.athleteDetailsSchoolsIdList;

  var committedSchoolContainer = null;
  var schoolName = null;
  var schoolLogo = null;
  var committedBadge = null;
  var committedLogo = null;

  if (athlete && schools) {
    if (
      schools &&
      athlete &&
      athlete.committedSchoolId &&
      athlete.committedSchoolId !== "" &&
      athlete.committedSchoolId !== null &&
      athlete.committed &&
      athlete.committedSchoolId !== "K3tyNyEJzpifALwIUC1F"
    ) {
      const schoolId = athlete.committedSchoolId;
      schoolName = schools[schoolId].name;
      schoolLogo = schools[schoolId].logo;

      committedLogo = <img src={schoolLogo} alt="School Logo" />;

      committedSchoolContainer = (
        <div className="CommittedSchoolContainer">
          <div className="CommittedSchoolLogoContainer">
            <img src={schoolLogo} alt="School Logo" />
          </div>
          <h5>{schoolName}</h5>
        </div>
      );
    } else {
      schoolName = null;
      schoolLogo = null;
      committedSchoolContainer = null;

      if (athlete.committed) {
        committedBadge = (
          <img
            src={require("../../images/committedBadge.svg").default}
            alt="Committed"
          />
        );
        committedLogo = (
          <img
            src={require("../../images/committedBadge.svg").default}
            alt="Committed"
          />
        );
      }
    }
  }

  var id = null;
  var isAdmin = false;

  if (props.adminId) {
    id = props.adminId;
    isAdmin = true;
  } else {
    id = props.match.params.id;
    isAdmin = false;
  }

  if (athlete) {
    const athleteSat = athlete.sat;
    const athleteAct = athlete.act;
    const athleteCommitted = athlete.committed;

    if (Number.isInteger(athlete.gpa)) {
      // gpa does NOT have decimal
      athleteGpa = athlete.gpa.toFixed(1);
    } else {
      // gpa HAS decimal
      athleteGpa = athlete.gpa;
    }

    var thumbnail = null;
    var hometown = null;
    var parentsFirstName = null;
    var parentsLabel = null;
    var ncaaId = null;
    var height = null;
    var weight = null;
    var jersey = null;
    var bats = null;
    var throws = null;

    var athleteJersey = null;

    var athleteAcademics = "";

    if (athleteGpa > 0) {
      athleteAcademics = "GPA " + athleteGpa;
    } else {
      athleteAcademics = "GPA";
    }

    if (athleteSat > 0) {
      athleteAcademics = athleteAcademics + "  SAT " + athleteSat;
    } else {
      athleteAcademics = athleteAcademics + "  SAT";
    }

    if (athleteAct > 0) {
      athleteAcademics = athleteAcademics + "  ACT " + athleteAct;
    } else {
      athleteAcademics = athleteAcademics + "  ACT";
    }

    var athletePrimaryPosition = null;
    var athleteSecondaryPosition = null;

    if (athlete.primaryPosition !== "" && athlete.primaryPosition !== "None") {
      // display Short Stop as Shortstop

      if (athlete.primaryPosition === "Short Stop") {
        athletePrimaryPosition = "Shortstop";
      } else {
        athletePrimaryPosition = athlete.primaryPosition;
      }
    }

    if (
      athlete.secondaryPosition !== "" &&
      athlete.secondaryPosition !== "None"
    ) {
      // display Short Stop as Shortstop

      if (athlete.secondaryPosition === "Short Stop") {
        athleteSecondaryPosition = "Shortstop";
      } else {
        athleteSecondaryPosition = athlete.secondaryPosition;
      }
    }

    var athletePosition = "";
    var classPosition = null;

    if (
      athlete.secondaryPosition === "" ||
      athlete.secondaryPosition === "None"
    ) {
      athletePosition = athletePrimaryPosition;
    } else {
      athletePosition =
        athletePrimaryPosition + ", " + athleteSecondaryPosition;
    }

    var athleteDetailsName = null;
    var athleteStatus = null;

    if (athlete.thumbnail !== "None") {
      thumbnail = <img src={athlete.thumbnail} alt="Athlete Thumbnail" />;
    } else {
      thumbnail = (
        <img src={require("../../images/user.svg").default} alt="User Icon" />
      );
    }

    if (athlete.hometown !== "") {
      hometown = <p>{athlete.hometown}</p>;
    }

    if (athlete.primaryPosition !== "None" && athlete.primaryPosition !== "") {
      classPosition = athletePosition;
    } else {
      classPosition = null;
    }

    if (athlete.parentOneFirstName !== "") {
      if (
        athlete.parentTwoFirstName !== "" &&
        athlete.parentOneFirstName !== ""
      ) {
        parentsFirstName = (
          <p>
            {athlete.parentOneFirstName} and {athlete.parentTwoFirstName}
          </p>
        );
        parentsLabel = <p>Parents: </p>;
      } else {
        if (athlete.parentOneLastName !== "") {
          parentsFirstName = (
            <p>
              {athlete.parentOneFirstName} {athlete.parentOneLastName}
            </p>
          );
          parentsLabel = <p>Parent: </p>;
        } else {
          parentsFirstName = <p>{athlete.parentOneFirstName}</p>;
          parentsLabel = <p>Parent: </p>;
        }
      }
    }

    if (athlete.parentTwoFirstName !== "") {
      if (
        athlete.parentTwoFirstName !== "" &&
        athlete.parentOneFirstName !== ""
      ) {
        parentsFirstName = (
          <p>
            {athlete.parentOneFirstName} and {athlete.parentTwoFirstName}
          </p>
        );
        parentsLabel = <p>Parents: </p>;
      } else {
        if (athlete.parentTwoLastName !== "") {
          parentsFirstName = (
            <p>
              {athlete.parentTwoFirstName} {athlete.parentTwoLastName}
            </p>
          );
          parentsLabel = <p>Parent: </p>;
        } else {
          parentsFirstName = <p>{athlete.parentTwoFirstName}</p>;
          parentsLabel = <p>Parent: </p>;
        }
      }
    }

    if (athlete.ncaaId > 0) {
      ncaaId = <p>#{athlete.ncaaId}</p>;
    }

    if (athlete.height !== "") {
      height = <p>{athlete.height}</p>;
    }

    if (athlete.weight > 0) {
      weight = <p>{athlete.weight} lbs</p>;
    }

    if (athlete.jersey !== "") {
      jersey = <p>#{athlete.jersey}</p>;
    }

    if (athlete.bats !== "") {
      bats = <p>{athlete.bats}</p>;
    }

    if (athlete.throws !== "") {
      throws = <p>{athlete.throws}</p>;
    }

    if (athlete.jersey && athlete.jersey !== "None") {
      athleteJersey = " #" + athlete.jersey;
    } else {
      athleteJersey = null;
    }

    const handleClick = (e, data) => {
      if (requestMoreInfo) {
        setRequestMoreInfo(false);
      } else {
        setRequestMoreInfo(true);

        document.body.style.overflow = "hidden";
      }
    };

    const handleRequestClose = (e, data) => {
      setRequestMoreInfo(false);

      document.body.style.overflow = "unset";
    };

    if (athleteCommitted) {
      athleteDetailsName = (
        <div className="AthleteDetailsNameContainer">
          <h3>
            {athlete.firstName} {athlete.lastName}
            {athleteJersey}
          </h3>
          {athlete.class === "college_transfer" ? (
            <h5>College Transfer</h5>
          ) : (
            <h5>Class of {athlete.class}</h5>
          )}
          {/* <h5>Class of {athlete.class}</h5> */}
          <h6>{classPosition}</h6>
          <div className="AthleteDetailsCommittedAcademics">
            <h4>COMMITTED</h4>
            {committedBadge}
          </div>
          {committedSchoolContainer}
        </div>
      );
      athleteStatus = (
        <div className="AthleteDetailsPersonalContainerRow">
          <div className="AthleteDetailsPersonalContainerRowTitle">
            <p>Status: </p>
          </div>
          <p>COMMITTED</p>
          {committedLogo}
        </div>
      );
    } else {
      athleteDetailsName = (
        <div className="AthleteDetailsNameContainer">
          <h3>
            {athlete.firstName} {athlete.lastName}
            {athleteJersey}
          </h3>
          {athlete.class === "college_transfer" ? (
            <h5>College Transfer</h5>
          ) : (
            <h5>Class of {athlete.class}</h5>
          )}
          {/* <h5>Class of {athlete.class}</h5> */}
          <h6>{classPosition}</h6>
          <div className="AthleteDetailsAcademics">
            <img
              src={require("../../images/gradCapDarkBlue.svg").default}
              alt="Graduation Cap"
            />
            <h6>{athleteAcademics}</h6>
          </div>
        </div>
      );
      athleteStatus = (
        <div className="AthleteDetailsPersonalContainerRow">
          <div className="AthleteDetailsPersonalContainerRowTitle">
            <p>Status: </p>
          </div>
          <p>Uncommitted</p>
        </div>
      );
    }

    var athleteSport = null;
    switch (athlete.sport.toLowerCase()) {
      case "soccer":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              src={require("../../images/soccerBall.svg").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      case "baseball":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              src={require("../../images/baseball.svg").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      case "basketball":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              src={require("../../images/basketball.svg").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      case "football":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              src={require("../../images/football.svg").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      case "volleyball":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              style={{ marginBottom: "1px" }}
              src={require("../../images/volleyball.png").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      case "softball":
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              style={{ marginBottom: "1px" }}
              src={require("../../images/softball.svg").default}
              alt="infoIcon"
            />
          </div>
        );
        break;
      default:
        // default is softball
        athleteSport = (
          <div className="AthleteDetailsPersonalContainerRow">
            <div className="AthleteDetailsPersonalContainerRowTitle">
              <p>Sport: </p>
            </div>
            <p>{athlete.sport}</p>
            <img
              src={require("../../images/softball.svg").default}
              alt="infoIcon"
            />
          </div>
        );
    }

    if (isAdmin) {
      return (
        <>
          <div>
            <div className="AthleteDetailsThumbnailContainer">{thumbnail}</div>
            {athleteDetailsName}
            <AthleteVideoList id={id} />
            <div className="AthleteDetailsInfoContainer">
              <div className="AthleteDetailsPersonalContainer">
                <div className="AthleteDetailsPersonalContainerTitle">
                  <h3>Personal Information</h3>
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Name: </p>
                  </div>
                  <p>
                    {athlete.firstName} {athlete.lastName}
                  </p>
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Grad Year: </p>
                  </div>
                  <p>
                    {athlete.class === "college_transfer"
                      ? "College Transfer"
                      : athlete.class}
                  </p>
                </div>
                {athleteStatus}
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Home: </p>
                  </div>
                  {hometown}
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    {parentsLabel}
                  </div>
                  {parentsFirstName}
                </div>
                <AthleteSocialMediaList id={id} />
              </div>
              <div className="AthleteDetailsPersonalContainer">
                <div className="AthleteDetailsPersonalContainerTitle">
                  <h3>Athletic Information</h3>
                </div>
                {athleteSport}
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Primary Position: </p>
                  </div>
                  <p>{athletePrimaryPosition}</p>
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Secondary Position: </p>
                  </div>
                  <p>{athleteSecondaryPosition}</p>
                </div>
                {athlete.sport == "Softball" || athlete.sport == "Baseball" ? (
                  <React.Fragment>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Bats: </p>
                      </div>
                      <p>{bats}</p>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Throws: </p>
                      </div>
                      <p>{throws}</p>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>NCAA: </p>
                  </div>
                  {ncaaId}
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Height: </p>
                  </div>
                  <p>{height}</p>
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Weight: </p>
                  </div>
                  <p>{weight}</p>
                </div>
                <div className="AthleteDetailsPersonalContainerRow">
                  <div className="AthleteDetailsPersonalContainerRowTitle">
                    <p>Jersey: </p>
                  </div>
                  {jersey}
                </div>
              </div>
            </div>
            <AthleteImageList id={id} />
            <AthleteCoachList id={id} athlete={athlete} />
            <AthleteAwardsHonorsList id={id} />
            <AthleteExtrasList id={id} />
            <AthleteEventsList id={props.idForEvents} />
            <AthleteCalendar id={id} />
            <AthletesStatsPhotos id={id} />
          </div>
        </>
      );
    } else {
      if (athlete.profilePublic) {
        var athleteInfoButton = null;

        if (athlete.committed) {
          athleteInfoButton = null;
        } else {
          athleteInfoButton = (
            <div className="AthleteDetailsButtonContainer">
              <Button
                icon
                labelPosition="left"
                color="blue"
                onClick={handleClick}
              >
                <Icon name="info circle" />
                Request Info on {athlete.firstName}
              </Button>
            </div>
          );
        }

        return (
          <>
            {/* {props.seo && (
              <Seo
                pathSlug={id}
                description={props.seo.description}
                keywords={props.seo.tags}
                title={`${athlete.firstName} ${athlete.lastName}`}
                thumbnail={athlete.thumbnail}
              />
            )} */}
            <div className="AthleteDetailsBackground">
              <div className="AthleteDetailsBannerBar"></div>
              {athleteInfoButton}
              <div className="AthleteDetailsGroupContainer">
                <div className="AthleteDetailsThumbnailContainer">
                  {thumbnail}
                </div>
                {athleteDetailsName}
                <AthleteVideoList id={id} />
                <div className="AthleteDetailsInfoContainer">
                  <div className="AthleteDetailsPersonalContainer">
                    <div className="AthleteDetailsPersonalContainerTitle">
                      <h3>Personal Information</h3>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Name: </p>
                      </div>
                      <p>
                        {athlete.firstName} {athlete.lastName}
                      </p>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Grad Year: </p>
                      </div>
                      <p>
                        {athlete.class === "college_transfer"
                          ? "College Transfer"
                          : athlete.class}
                      </p>
                    </div>
                    {athleteStatus}
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Home: </p>
                      </div>
                      {hometown}
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        {parentsLabel}
                      </div>
                      {parentsFirstName}
                    </div>
                    <AthleteSocialMediaList id={id} />
                  </div>
                  <div className="AthleteDetailsPersonalContainer">
                    <div className="AthleteDetailsPersonalContainerTitle">
                      <h3>Athletic Information</h3>
                    </div>
                    {athleteSport}
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Primary Position: </p>
                      </div>
                      <p>{athletePrimaryPosition}</p>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Secondary Position: </p>
                      </div>
                      <p>{athleteSecondaryPosition}</p>
                    </div>
                    {athlete.sport == "Softball" ||
                    athlete.sport == "Baseball" ? (
                      <React.Fragment>
                        <div className="AthleteDetailsPersonalContainerRow">
                          <div className="AthleteDetailsPersonalContainerRowTitle">
                            <p>Bats: </p>
                          </div>
                          <p>{bats}</p>
                        </div>
                        <div className="AthleteDetailsPersonalContainerRow">
                          <div className="AthleteDetailsPersonalContainerRowTitle">
                            <p>Throws: </p>
                          </div>
                          <p>{throws}</p>
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )}

                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>NCAA: </p>
                      </div>
                      {ncaaId}
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Height: </p>
                      </div>
                      <p>{height}</p>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Weight: </p>
                      </div>
                      <p>{weight}</p>
                    </div>
                    <div className="AthleteDetailsPersonalContainerRow">
                      <div className="AthleteDetailsPersonalContainerRowTitle">
                        <p>Jersey: </p>
                      </div>
                      {jersey}
                    </div>
                  </div>
                </div>
                <AthleteImageList id={id} />
                <AthleteCoachList id={id} athlete={athlete} />
                <AthleteAwardsHonorsList id={id} />
                <AthleteExtrasList id={id} />
                {/* <AthleteEventsList id={id} /> */}
                <AthleteEventsList id={props.idForEvents} />
                <AthleteCalendar id={id} />
                <AthletesStatsPhotos id={id} />
              </div>
              <AthleteRequestForm
                id={id}
                athlete={athlete}
                request={requestMoreInfo}
                requestClose={handleRequestClose}
              />
            </div>
          </>
        );
      } else {
        // profile archived

        return (
          <>
            <div className="SpinnerBackground">
              <div className="SpinnerContainer">
                <Loader size="large" active inline="centered" />
              </div>
            </div>
          </>
        );
      }
    }
  } else {
    return (
      <>
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      </>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  var id = null;
  let gettingId;
  let gettingIdKeys;
  let idForEvents;
  if (ownProps.adminId) {
    id = ownProps.adminId;
  } else {
    id = ownProps.match.params.id;
  }
  const athletes = state.firestore.data.athletes;

  const athlete = athletes ? athletes[id] : null;
  if (state.firestore.data.adminAthletes) {
    gettingId = state.firestore.data.adminAthletes;
    gettingIdKeys = Object.keys(gettingId);
    gettingIdKeys.forEach((idForEvent) => {
      if (state.firestore.data.adminAthletes[idForEvent] && athlete) {
        if (
          state.firestore.data.adminAthletes[idForEvent].customUrl ===
          athlete.customUrl
        ) {
          idForEvents = idForEvent;
        }
      }
    });
  }

  return {
    athlete: athlete,
    athleteDetailsSchoolsIdList:
      state.firestore.data.athleteDetailsSchoolsIdList,
    // seo: seo,
    idForEvents,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "athletes",
    },
    {
      collection: "schools",
      storeAs: athleteDetailsReduxSchoolsIdList,
    },
    {
      collection: "testSEO",
    },
    {
      collection: "adminAthletes",
    },
  ])
)(AthleteDetails);
